export default "__VITE_ASSET__Dahv6RYD__"